import { type MutationResolvers } from '../../../../generated/graphql'
import { type ApolloResolverContext } from '@edge/spark/io-apollo'
import { setIsEditingLayouts } from '../../../../Stores'

export const endEditingLayoutsResolver: MutationResolvers<ApolloResolverContext>['endEditingLayouts'] = () => {
    console.debug('io-dashboards endEditingLayoutsResolver deprecated, use setIsEditingLayouts')
    setIsEditingLayouts(false)
    return false
}
